// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.585938L14.9728 3.55873L15.9356 18.0002H17V23.0002H7V18.0002H8.06445L9.02721 3.55873L12 0.585938ZM10.0689 18.0002H13.9311L13.0272 4.44157L12 3.41436L10.9728 4.44157L10.0689 18.0002Z"}}]};

const Tower2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tower-2-filled',
    ref,
    icon: element,
  },
));

Tower2FilledIcon.displayName = 'Tower2FilledIcon';

export default Tower2FilledIcon;
